import React from 'react';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

function ProductTile({
  productShortName = '',
  logo,
  description,
  bgImage,
  className,
  iconClassName,
  title,
}) {
  return (
    <div
      className={twMerge(
        'relative flex h-[250px] w-[250px] items-end rounded-2xl px-3 py-5 transition-all ease-linear hover:scale-105',
        className,
      )}
      title={title}
    >
      <img className="absolute inset-0" src={`/assets/${bgImage}`} alt="worley consulting" />
      <div className="relative space-y-4">
        <div
          className={twMerge(
            'inline-block h-11 w-11 rounded-lg bg-lush-green-50 text-center text-[22px] font-bold leading-[44PX] text-lush-green-80',
            iconClassName,
          )}
        >
          {productShortName}
        </div>
        <img src={`/assets/${logo}`} alt={title} />
        <p className="line-clamp-2 min-h-12 font-normal text-white">{description}</p>
      </div>
    </div>
  );
}

export default ProductTile;

ProductTile.propTypes = {
  productShortName: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  bgImage: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
